import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { toast } from '../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../CommonConstants';
import { WidgetsDTO } from './useWidgetsQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../_hooks/useClientId';
import { TabSlug } from '../types';

interface FetcherParams {
  tab: TabSlug;
  widgets: WidgetsDTO;
}

const mutateWidgets = ({ tab, widgets }: FetcherParams): Promise<WidgetsDTO> => {
  return authFetch(urlWithParams('/Adviser/WidgetConfigurationUpdate', { tab }), {
    method: 'POST',
    ...httpBodyOptions(widgets, true),
  });
};

interface QueryParams {
  tab: TabSlug;
}

export const useWidgetsMutation = ({ tab }: QueryParams) => {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  const queryKey = queryKeys.widgets(clientId, tab);

  return useMutation(mutateWidgets, {
    onSuccess(data) {
      queryClient.setQueryData(queryKey, data);
    },

    onError() {
      queryClient.setQueryData(queryKey, queryClient.getQueryData(queryKey));

      toast.error(MESSAGES.GENERIC_ERROR);
    },
  });
};
